import { LayoutDocumentoResponseModelo } from '@/api/generated/model';

/**
 * Nomes e descrições dos cinco papéis timbrados.
 *
 * O backend manda só o valor do enum (`FAIXA`), como faz com o status do
 * receituário — o vocabulário de produto mora aqui, na fronteira.
 */
export type Modelo =
  (typeof LayoutDocumentoResponseModelo)[keyof typeof LayoutDocumentoResponseModelo];

export const MODELOS = Object.values(LayoutDocumentoResponseModelo);

export const ROTULO_MODELO: Record<Modelo, string> = {
  CLASSICO: 'Clássico',
  FAIXA: 'Faixa colorida',
  MOLDURA: 'Moldura',
  MINIMALISTA: 'Minimalista',
  COMPACTO: 'Compacto',
};

export const DESCRICAO_MODELO: Record<Modelo, string> = {
  CLASSICO: 'O papel de sempre',
  FAIXA: 'Faixa de cor no topo',
  MOLDURA: 'Formal, com borda na página',
  MINIMALISTA: 'Sem molduras, muito branco',
  COMPACTO: 'Cabe mais coisa na folha',
};

// Cores (CORES_SUGERIDAS, HEX, COR_PADRAO) moradas em @/shared/lib/cores —
// deixaram de ser específicas de documentos quando features/analises passou
// a precisar do mesmo controle (cor do grupo de estudo).
